import angular from 'angular';

module.exports = angular.module('market.models.vendor-question', [])
.factory('VendorQuestion', function($resource) {
  return $resource('/api/v1/vendor_questions/:id', { id: '@id' }, {
    save: {
      method: 'POST',
      toast: {
        success: 'Message submitted',
        error: 'Failed to submit message'
      }
    },
  });
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/models/vendor-question.js
 **/